import { ECommBrand } from '../e-comm/models/ECommBrand';
import { SearchResultBrand } from '../search/models/SearchResultBrand';

import { Overlap } from 'common/definitions/Overlap';

export type UniversalBrand = Overlap<SearchResultBrand, ECommBrand>;

export const emptyUniversalBrand: UniversalBrand = {
    id: 0,
    name: '',
    imageUrl: '',
};
